import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { loadGoogleAnalytics } from '@/lib/analytics';

export const CookieConsent = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already consented
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            // Small delay for better UX
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
        // Visitante que ya habia aceptado antes (localStorage persiste entre visitas) --
        // cargar Analytics de nuevo, ya que el script en si no se guarda entre sesiones.
        if (consent === 'accepted') {
            loadGoogleAnalytics();
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        loadGoogleAnalytics();
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie-consent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 md:bottom-6 md:left-auto md:right-6 md:max-w-md z-50 animate-in slide-in-from-bottom-10 duration-500">
            <div className="bg-white/95 backdrop-blur-xl border-t md:border border-white/20 shadow-2xl rounded-t-3xl md:rounded-3xl p-4 sm:p-6 relative overflow-hidden">
                {/* Background Accents */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-purple-200/30 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-pink-200/30 rounded-full blur-3xl"></div>

                <div className="relative z-10">
                    <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                        <span className="text-2xl sm:text-3xl">🍪</span>
                        <h3 className="text-base sm:text-xl font-bold text-gray-900">
                            {t('cookies.title', '¡Usamos cookies!')}
                        </h3>
                    </div>

                    <p className="text-gray-600 mb-3 sm:mb-4 leading-snug text-xs sm:text-sm line-clamp-2 sm:line-clamp-none">
                        {t('cookies.description', 'Utilizamos cookies para mejorar tu experiencia, analizar el uso de nuestra plataforma y mostrarte contenido que te encante.')}
                    </p>

                    <div className="flex flex-row gap-2 sm:gap-3">
                        <button
                            onClick={handleAccept}
                            className="px-3 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl hover:shadow-lg hover:scale-[1.02] active:scale-95 transition-all text-xs sm:text-sm flex-1"
                        >
                            {t('cookies.accept', 'Aceptar todo')}
                        </button>
                        <button
                            onClick={handleDecline}
                            className="px-3 sm:px-6 py-2 sm:py-3 bg-gray-100 text-gray-600 font-semibold rounded-2xl hover:bg-gray-200 active:scale-95 transition-all text-xs sm:text-sm flex-1"
                        >
                            {t('cookies.decline', 'Solo necesarias')}
                        </button>
                    </div>

                    <div className="mt-2 sm:mt-3 text-center">
                        <Link to="/privacidad" className="text-[11px] sm:text-xs text-gray-400 hover:text-purple-600 transition-colors underline">
                            {t('cookies.moreInfo', 'Más información')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
